import React, { createContext, useContext } from "react";

export const HistLabel = createContext("media 12 m");

// Referencia a la media histórica: valor medio y desviación del mes actual.
export const Hist = ({ cur, hist, fmt, pp = false, inverse = false, className = "", testid }) => {
  const label = useContext(HistLabel);
  if (hist == null || cur == null) return null;
  const diff = pp ? (cur - hist) * 100 : hist ? (100 * (cur - hist)) / Math.abs(hist) : null;
  const good = diff == null || Math.abs(diff) < 0.05 ? null : inverse ? diff < 0 : diff > 0;
  const color = good == null ? "text-slate-400" : good ? "text-emerald-600" : "text-red-600";
  return (
    <div className={`text-[10px] leading-tight font-normal text-slate-400 whitespace-nowrap ${className}`} data-testid={testid}>
      {label} {fmt(hist)}
      {diff != null && (
        <span className={`ml-1 font-semibold ${color}`}>
          {good == null ? "=" : diff > 0 ? "▲" : "▼"} {diff > 0 ? "+" : ""}{diff.toFixed(1)}{pp ? " pp" : "%"}
        </span>
      )}
    </div>
  );
};
